"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultBg = exports.getBgColor = void 0;
var getDefaultBg = exports.getDefaultBg = function getDefaultBg() {
  var div = document.createElement('div');
  document.head.appendChild(div);
  var bg = window.getComputedStyle(div).backgroundColor;
  document.head.removeChild(div);
  return bg;
};
var _getBgColor = exports.getBgColor = function getBgColor(el) {
  var defaultBgColor = getDefaultBg();
  if (!el) {
    return defaultBgColor;
  }
  var _window$getComputedSt = window.getComputedStyle(el),
    backgroundColor = _window$getComputedSt.backgroundColor;
  if (backgroundColor !== defaultBgColor) {
    return backgroundColor;
  }
  if (!el.parentElement) {
    return defaultBgColor;
  }
  return _getBgColor(el.parentElement);
};